











import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';
import {HTML_SERVICE_INSTANCE} from '@/services/html.service';

/**
 * Ametras Formular Wrapper
 *
 * Extends the Vuetify Form with the following functionalities:
 *  - focusFirstInvalidField focusses the first invalid field (if any)
 *  - validate will call Vuetify.Form.validate() and additionally focusFirstInvalidField
 */
@Component({
  mixins: [BindAttrs]
})
export default class AmetrasFormularWrapper extends Vue {

  @Prop() value: boolean | undefined;

  $refs!: {
    // unfortunately there is no exact type available.
    // See official doc: https://vuetifyjs.com/en/components/forms/
    form: any
  };

  /**
   * Focusses the first invalid field (if any)
   */
  focusFirstInvalidField(): void {
    const fieldsContainingErrors = this.$refs.form.$el.querySelectorAll('.error--text');
    if (fieldsContainingErrors && fieldsContainingErrors.length) {
      HTML_SERVICE_INSTANCE.focusFirstNode(fieldsContainingErrors[0]);
    }
  }

  /**
   * Calls Vuetify.Form.resetValidation()
   */
  resetValidation(): void {
    this.$refs.form.resetValidation();
  }

  /**
   * Calls Vuetify.Form.validate() and focusses first invalid field (if any)
   */
  validate(): boolean {
    const result = this.$refs.form.validate();
    if (!result) {
      this.$nextTick(() => {
        this.focusFirstInvalidField();
      });
    }
    return result;
  }

}
